import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabase/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCustomersByRestaurant = (restaurantId) => {
  return useQuery({
    queryKey: ['customers', restaurantId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('customers')
        .select('id, phone, email, name, reservations, created_at,no_show_count')
        .eq('restaurant_id', restaurantId)
        .order('created_at', { ascending: false }); // Default order by newest
      if (error) throw error;
      if (!data || data.length === 0) return [];
      return data.map((customer) => ({
        ...customer,
        id: customer.id,
        phone: customer.phone || 'N/A',
        email: customer.email || 'N/A',
        name: customer.name || 'N/A',
        reservations: customer.reservations || 0,
        created_at: customer.created_at,
      }));
    },
    enabled: !!restaurantId && !!supabase.auth.getSession(),
  });
};




export const useUpdateCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ customerId, name, phone, email }) => {
      const { data, error } = await supabase
        .from('customers')
        .update({ name, phone, email })
        .eq('id', customerId)
        .select('id, phone, email, name, reservations, created_at');
      if (error) throw error;
      return data[0];
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      queryClient.invalidateQueries({ queryKey: ['customer', data.id] });
    },
  });
};




export const useCustomerbyID = (id) => {
  return useQuery({
    queryKey: ['customers', id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('customers')
        .select('*')
        .eq('id', id)
        .single();
        
      if (error) {
        // Handle the case where no customer is found
        if (error.code === 'PGRST116') {
          return null; // No rows returned
        }
        throw error;
      }
      
      return data; // data will be a single object or null
    },
    enabled: !!id, // Simplified condition - just check if id exists
  });
};